<template>
    <v-container
        fill-height
        fluid
    >
    {{Prenotazione.Nominativo}}
    {{Prenotazione.Arrivo}}
    {{Prenotazione.Partenza}}
    {{Prenotazione.Totale}}
    {{Prenotazione.Saldo}}
        asasa
    </v-container>
</template>
<script>
export default {
    data: () => ({
    Prenotazione: {
        IdPrenotazione: 791382,
        PIN: 4245,
        Nominativo: "vers maria fresi",
        Arrivo: "07/03/2020",
        Partenza: "07/03/2020",
        Note: "",
        IdGestionale: "",
        Fonte: "",
        IdSource: "",
        IdOTA: "",
        DataInserimento: "21/02/2020 15:48",
        DataOpzione: "21/02/2020",
        Gruppo: "",
        Mail: "avvisi@quasarsoft.net",
        Telefono: "",
        Prepagata: 0,
        Soggiorno: 0,
        Extra: 0,
        ImpostaDiSoggiorno: 0,
        Caparra: 0,
        StatoCaparra: "NP",
        DepositoCauzionale: 0,
        StatoDepositoCauzionale: "NP",
        PrezzoACorpo: 0,
        Totale: 0,
        Saldo: 0,
        Lingua: "",
        NoteSensibili: "",
        NotePerOspiti: "",
        Targa1: "",
        Targa2:"",
        Targa3:"",
        UltimaModifica:"21/02/2020 15:59",
        Bloccata:0,
        BloccaInvioRecensione:0,
        Stagionale:0,
        Trattamento:{
            Id:128,
            IdGestionale:"BB",
            Descrizione:"Bed & Breakfast",
            Tipo:"BeB"
        },
        Risorsa:{
            IdPrenotazioneRisorsa:1871875,
            IdRisorsa:1322,
            DescrizioneRisorsa:"104 MATR",
            IdGestionaleRisorsa:"B5E70798-7B3D-4266-BB20-69F2FFA42F8D",
            IdTipologia:160,
            DescrizioneTipologia:"MAT STD",
            IdGestionaleTipologia:"182800D9-C428-4501-8670-2430DC76FC3F",
            Dal:"07/03/2020",
            Al:"11/03/2020",
            Allestimento:"",
            CapoRisorsa:"vers maria fresi",
            TotaleRisorsa:0,
            Note:"",
            IdProdotto:1,
            IdGestioaleProdotto:"",
            RisorsaBloccata:0,
            NoteSala:"",
            Trattamento:{
                Id:128,
                IdGestionale:"BB",
                Descrizione:"Bed & Breakfast",
                Tipo:"BeB"
            },
            Periodo:{
                Dal:"07/03/2020",
                Al:"11/03/2020",
                RettaGG:0,
                ScontoPercentuale:0,
                ScontoAssoluto: 0,
                PrezzoACorpo: 0,
                NotePeriodo: ""
            }
        },
        Ospite:[
            {
                TipoAlloggiato: 17
            },
            {
                TipoAlloggiato: 19
            }
        ]
    }
    })
}
</script>